import axios from "axios";
import { APIResponse, BlockType, Document, DocumentBlock, Project, User } from "Classes";
import moment from "moment";

const PAGE=process.env.REACT_APP_PAGE;
const CDN_URL=process.env.REACT_APP_CDN_URL;
const ROOT_URL = process.env.REACT_APP_API_URL;
const DEBUG = process.env.REACT_APP_DEBUG==='1';
const PAGE_AUTH=process.env.REACT_APP_AUTH_URL || null;
const LOGIN_SOURCE=process.env.REACT_APP_LOGIN_SOURCE || null;

interface PostOptions{
	login?: boolean,
	response_type?: ResponseType,
	access_token?: string,
}

function getUser(){
   var jsonUser=localStorage.getItem('user');
   if(!jsonUser)return null;
   try{
      var user=JSON.parse(jsonUser) as User;
      var now=moment().unix();
      if(!user || !user.token || user.token.access<=(now+30))return null;
      return user;
   }catch{
      return null;
   }
}

function logout(){
	localStorage.removeItem('user');
	window.dispatchEvent(new Event('user_data'));
}

async function post<T=any>(endpoint: string, data?: any, opts: PostOptions={}) : Promise<APIResponse<T>>{
	var options = {
		headers: {
			'show-code': DEBUG ? '1' : '0',
			'token': '',
			'Content-Type': 'application/json'
		}
	}
	if(opts?.login!==false){
		if(opts?.access_token){
			options.headers.token = opts.access_token;
		}else{
			var u = getUser();
			if(u?.token){
				options.headers.token = u.token.token;
			}
		}
	}
	if(data instanceof FormData){
		options.headers['Content-Type'] = 'multipart/form-data';
	}
	try{
		var ENDPOINT = `${ROOT_URL}/${endpoint}`;
		if(DEBUG) console.log("POST "+ENDPOINT);
		var res = await axios.post(ENDPOINT, data, {
			...options,
			responseType: (opts?.response_type || 'json') as any
		});
		if(DEBUG) console.log(`=>Response: ${(parseInt(res.headers['content-length'])/1024).toFixed(2)} KB`);
		if(res.data && res.data.error && res.data.code==='P-TKNE'){
			logout();
		}
		return res.data as APIResponse<T>;
	}catch(err){
		if(DEBUG) console.error(err);
		if((err as any)?.code==="ERR_NETWORK"){
			return {
				error: true, 
				message: 'No se pudo establecer una conexión con el servidor. (API-NONTWK)',
				code: 'API-NONTWK',
			}
		}
		return {
			error: true, 
			message: 'Hubo un error inesperado (API-LCL-1)',
			code: 'API-LCL-1',
		}
	}
};

function getAuhtUrl(): string | null{
   if(!PAGE_AUTH || !LOGIN_SOURCE) return null;
   return `${PAGE_AUTH}/admin?s=${LOGIN_SOURCE}&continue=${encodeURIComponent(`${window.location.origin}/auth`)}&redirect=${encodeURIComponent(window.location.href)}`;
};

function authToken(token: string){
   return post('user/auth/login', { token });
};

function getProjects(){
	return post<Project[]>('project/list');
};

function createProject(project_name: string, system_key: string){
	return post('project/create', {project_name, system_key})
};

function editProject(project_name: string, status: number, project_id: number, system_key?: string){
	return post('project/edit', {project_name,status,project_id,system_key});
};

function createDocument(project_id: number, title: string){
	return post('document/create', {project_id, title});
};

function updateDocument(document_id: number, title: string, status: number){
	return post('document/edit', {document_id, title, status});
};

function getDocuments(project_id: number){
	return post<Document[]>('document/list', {project_id});
};

function getBlockTypes(){
	return post<BlockType[]>('block_type/list');
};

function createDocumentBlock(document_id: number, block_type: number, content: string, priority: number){
	return post('document_block/create', {document_id, block_type, content, priority});
};

function updateDocumentBlock(block_id: number, content: string){
	return post('document_block/edit', {block_id, content});
};

function deleteDocumentBlock(block_id: number){
	return post('document_block/delete', {block_id});
};

function getDocumentBlocks(document_id: number){
	return post<DocumentBlock[]>('document_block/list', {document_id})
}

function reorderDocumentBlocks(blocks: {block_id: number, priority: number}[]){
	return post('document_block/reorder', {blocks});
}

function getUsers(){
        return post<User[]>('user/list');
}

export {
   PAGE,
   CDN_URL,
   authToken,
   getAuhtUrl,
   getUsers,
	editProject,
	getProjects,
	getDocuments,
	createProject,
	getBlockTypes,
	createDocument,
	updateDocument,
	getDocumentBlocks,
	createDocumentBlock,
	updateDocumentBlock,
	deleteDocumentBlock,
   reorderDocumentBlocks,
}